import {useCommunityStore} from '@/Store/community/community.selector';

const useOpenTalentReport = () => {
  const {setTalentReport} = useCommunityStore().actions;
  return setTalentReport;
};
export default useOpenTalentReport;
